


































import BaseFilter from '@/components/Filter/BaseFilter';
import { Component, PropSync} from 'vue-property-decorator';
import { PushGroupsApplicationFilter } from '@/store/push/groups_application/types';
import { SelectWings, ToggleWings } from 'wings-ui-components';
import { Action } from 'vuex-class';
import {notifyError, notifyWarning} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({ components: { SelectWings, ToggleWings } })
export default class PushGroupsApplicationsFilter extends BaseFilter<PushGroupsApplicationFilter> {
  @PropSync('show') is_show!: boolean;
  @Action("getGroupsApplications") actionGetGroupsApplications: any;

  async created() {
    try {
      await this.onFilteredAction();
    } catch (error) {
      notifyError(error);
    }
  }

  defaultFilter(): PushGroupsApplicationFilter {
    return {
      name: undefined,
      description: undefined,
      partner: undefined
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Push-applications group",
        addititional_info: getTranslatedParams(this.filter)
      }
      await this.actionGetGroupsApplications(this.filter);
      await this.actionLog(this.logObject);
    } catch(error) {
      this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
};
